import { Controller, useFormContext } from "react-hook-form";
import styled from "styled-components";
import { DateField } from "../../../../components/forms/date";

const Entry = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: space-between;
`;

export function Between() {
  const { control } = useFormContext();

  return (
    <div>
      <Entry>
        <div style={{ marginRight: "1em" }}>Start</div>
        <Controller
          control={control}
          name="between.start"
          render={({ field, fieldState: { error } }) => (
            <DateField {...field} error={!!error} helperText={error?.message} />
          )}
        />
      </Entry>
      <Entry>
        <div style={{ marginRight: "1em" }}>End</div>

        <Controller
          control={control}
          name="between.end"
          render={({ field, fieldState: { error } }) => (
            <DateField {...field} error={!!error} helperText={error?.message} />
          )}
        />
      </Entry>
    </div>
  );
}
